import { render, staticRenderFns } from "./SelectionWindow.vue?vue&type=template&id=0865b64e&scoped=true&"
import script from "./SelectionWindow.vue?vue&type=script&lang=js&"
export * from "./SelectionWindow.vue?vue&type=script&lang=js&"
import style0 from "./SelectionWindow.vue?vue&type=style&index=0&id=0865b64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865b64e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
